import { Head } from "@inertiajs/react"
import { AppLayout } from "../../components/layout/AppLayout"
import { CompanyForm } from "../../features/companies/CompanyForm"

type NewCompanyPageProps = {
  company: {
    name: string
    cnpj: string
    omie_key: string
    omie_secret: string
    omie_email_copy: string
    modo_emissao: "web" | "txt" | "web_e_txt"
  }
  errors?: Record<string, string[]>
}

export default function NewCompanyPage({ company, errors }: NewCompanyPageProps) {
  return (
    <>
      <Head title="Nova Empresa" />
      <AppLayout>
        <div className="mx-auto w-full max-w-6xl p-8">
          <div className="mb-6">
            <h1 className="text-3xl font-bold text-white">Nova Empresa</h1>
            <p className="text-slate-400">Cadastre empresa e regras de emissão.</p>
          </div>
          <CompanyForm initialValues={company} submitUrl="/empresas" submitLabel="Criar empresa" method="post" errors={errors} />
        </div>
      </AppLayout>
    </>
  )
}
